module.exports = __webpack_public_path__ + "img/circle-silver-blank-large.db4ac4bf.png";